import axios, { getVariable } from "./api";
import { closeGlobalLoading, globalLoading } from "./loading";
import { globalPopup, closeGlobalPopup } from "./popup";
import { keycloak } from "../components/auth";

export const updateUserLS = (user) => {
  let updatedUser = Object.assign(
    JSON.parse(localStorage.getItem("userInfo")),
    user
  );

  window.GLOBALS.user.info = updatedUser;

  localStorage.setItem("userInfo", JSON.stringify(updatedUser));
};

export const setUser = async (userdata) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  if (!window.OFFLINE.isOffline && userdata.cpf !== undefined) {
    console.log("Salvando dados do usuário...");
    globalLoading("Salvando dados do usuário...");

    return axios
      .post(
        (await getVariable("CONHECIGAME_API")) + "/setuser/" + userdata.cpf,
        userdata,
        headers
      )
      .then((data) => {
        closeGlobalLoading();
        return data;
      })
      .catch((err) => {
        mostraErro(err);
      });
  } else {
    window.OFFLINE.stack.push({
      action: "setUser",
      params: userdata,
    });

    localStorage.setItem("OFFLINE_STACK", JSON.stringify(window.OFFLINE.stack));
  }
};

export const mostraErro = (err) => {
  globalPopup(
    "Erro: Acesso ao servidor! (5)",
    true,
    [
      {
        texto: "OK",
        acao: () => {
          closeGlobalPopup();
        },
      },
    ],
    "No momento não foi possível conectar ao servidor. Por favor tente mais tarde.\r\n\r\nObrigado."
  );

  console.log("user js");
  console.log("WS Partidas Error: ", err);
};

export const updateUser = async (userdata) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios
    .put(
      (await getVariable("CONHECIGAME_API")) + `/v1/usuario/${userdata.id}`,
      userdata,
      headers
    )
    .then((data) => data)
    .catch((err) => {
      console.error("Não foi possível atualizar o usuario", err);
    });
};
